import { Injectable } from '@angular/core';
import { GenericHttpService } from './genericHttpService';
import {AppService} from '../app/app.service';
import {HttpClient} from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  applicationApiClient: GenericHttpService;
  accountApiClient: GenericHttpService;
  tenantApiClient: GenericHttpService;
  aiAssistantApiClient: GenericHttpService;

  constructor(private appService: AppService,
              private httpClient: HttpClient) {
    this.initializeAccountClient();
    this.initializeTenantClient();
    this.initializeAiAssistantClient();
  }

  private initializeAccountClient() {
    this.accountApiClient = new GenericHttpService(this.appService, this.httpClient, environment.accountApiUrl);
  }

  initializeApplicationClient(url: string) {
    this.applicationApiClient = new GenericHttpService(this.appService, this.httpClient, url);
  }

  private initializeTenantClient() {
    this.tenantApiClient = new GenericHttpService(this.appService, this.httpClient, environment.tenantApiUrl);
  }

  private initializeAiAssistantClient() {
    this.aiAssistantApiClient = new GenericHttpService(this.appService, this.httpClient, environment.aiApiUrl);
  }
}
